export default __webpack_public_path__ + "static/media/magic_dogs.94acbfb3.gif";